import { WebullConnect as WebullConnectComponent } from '../components/WebullConnect';

export const WebullConnect = () => {
  return <WebullConnectComponent />
}